module.exports = __webpack_public_path__ + "app/referentials/referential-config/attribut-draggable-table-3lNeML4M.html";